export default import.meta.ROLLDOWN_FILE_URL_HPRYTZf1UsRU8iiTZZoweQ